import React from "react";

const SkeletonTable = ({ rows = 5, cols = 1 }) => {
  const safeRows = Math.max(1, Number(rows) || 5);
  const safeCols = Math.max(1, Number(cols) || 1);

  return (
    <div
      className="wms-pill-table-root w-full overflow-visible font-nunito text-[#161616]"
      style={{ backgroundColor: "transparent", padding: 0 }}
      role="status"
      aria-live="polite"
      aria-label="Loading table rows"
    >
      <div
        className="wms-pill-table-card overflow-visible"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EEF1F5",
          borderRadius: 16,
          boxShadow: "0 2px 10px rgba(16,24,40,0.04)",
          padding: 18,
        }}
      >
        <div className="wms-pill-table-scroll overflow-x-auto overflow-y-visible">
          <table
            className="wms-pill-table w-full text-[#161616]"
            style={{ borderSpacing: "0 14px", borderCollapse: "separate", border: "none" }}
          >
            <tbody>
              {Array.from({ length: safeRows }).map((_, rowIdx) => (
                <tr key={`skeleton-row-${rowIdx}`}>
                  {Array.from({ length: safeCols }).map((__, colIdx) => (
                    <td
                      key={`skeleton-cell-${rowIdx}-${colIdx}`}
                      className="whitespace-nowrap border-none text-base font-medium h-16"
                      style={{
                        border: "none",
                        borderBottom: "1px solid #F2F4F7",
                        paddingLeft: 22,
                        paddingRight: 22,
                      }}
                    >
                      <div className="h-4 bg-gray-200 rounded animate-pulse w-full max-w-[180px]" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SkeletonTable;
